// extracted by mini-css-extract-plugin
export default {"old":"NewAdmin_old__pCo2M","new":"NewAdmin_new__+pc56"};